// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1L6LF","content":"styles_content__2wm2Q","row":"styles_row__19Omj","footer":"styles_footer__3JnGC","phraseLength":"styles_phraseLength__1P1Sy"};